import { Home01Icon as HomeIcon } from '@repo/studio-design-system-ui-icons/general/home-01'
import * as React from 'react'
import { ROUTES } from '@repo/studio-utils/routes'
import { useStudioTranslate } from '@repo/studio-config/studio-config-context'
import type { SingularNavigationItem } from '@repo/studio-config/studio-config-context'
import { NavigationItem } from './navigation-item'
import { m } from 'framer-motion'

export function NavigationHomeItem({
  route = ROUTES.STUDIO.HOME,
  expanded,
  onNavigate,
}: {
  route?: string
  expanded: boolean
  onNavigate?: () => void
}) {
  const t = useStudioTranslate()

  return (
    <NavigationItem
      title={t('studio.home.common.home')}
      route={route}
      expanded={expanded}
      icon={<HomeIcon />}
      onNavigate={onNavigate}
      exact={true}
    />
  )
}

export function SingularNavigationItems({
  items,
  expanded,
  onNavigate,
}: {
  items: SingularNavigationItem[] | undefined
  expanded: boolean
  onNavigate?: () => void
}) {
  return (
    items?.map(item => (
      <NavigationItem
        key={item.route}
        title={item.title}
        route={item.route}
        expanded={expanded}
        icon={item.icon}
        exact={item.exact}
        hardNavigation={item.hardNavigation}
        onNavigate={onNavigate}
      />
    )) ?? null
  )
}

export function NavigationSectionTitle({
  category,
  ...props
}: {
  category: 'ai' | 'more'
} & React.ComponentProps<typeof m.span>) {
  const t = useStudioTranslate()
  const title = t(`studio.clusters.titles.${category}`)
  return (
    <m.span
      className="px-2 pb-2 typography-12 text-gray-500 line-clamp-1 overflow-clip h-[26px]"
      {...props}
    >
      {title}
    </m.span>
  )
}
